import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../core/layout/Dialog';
import get from 'lodash/get';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import LocalFileInput from '../../../core/form/LocalFileInput';
import TextInput from '../../../core/form/TextInput';
import Separator from '../../../core/layout/Separator';
import Button from '../../../core/form/Button';

const WhitelabelConfigMobileDistributionForm = (props) => (
  <Dialog title="Distribution Config" isOpen={props.isOpen} onCancel={props.onDiscard} actions={null} width="75%">
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Row>
        <Column size={6}>
          <LocalFileInput
            disabled={props.submitting}
            label="Splash screen logo"
            value={get(props.values, 'splashScreenIconUrl', '')}
            onChange={(value) => props.onChange('splashScreenIconFile', value)}
            errorText={get(props.errors, 'splashScreenIconFile', null)}
            accept="image"
          />
          <small style={{ position: 'absolute', bottom: 6 }}>
            1024x1024 image only with the logo/icon in center to be use as content for splash screen
          </small>
        </Column>
      </Row>
      <Row>
        <Column size={4}>
          <LocalFileInput
            disabled={props.submitting}
            label="iOS Icon"
            value={get(props.values, 'iosIconUrl', '')}
            onChange={(value) => props.onChange('iosIconFile', value)}
            errorText={get(props.errors, 'iosIconFile', null)}
            accept="image"
          />
          <small style={{ position: 'absolute', bottom: 6 }}>
            1024x1024 image that will be used as the icon for iOS app
          </small>
        </Column>
      </Row>
      <Row>
        <Column size={4}>
          <LocalFileInput
            disabled={props.submitting}
            label="Android Icon"
            value={get(props.values, 'androidIconUrl', '')}
            onChange={(value) => props.onChange('androidIconFile', value)}
            errorText={get(props.errors, 'androidIconFile', null)}
            accept="image"
          />
          <small style={{ position: 'absolute', bottom: 6 }}>
            1024x1024 image that will be used as the icon for Android app
          </small>
        </Column>
        <Column size={4}>
          <LocalFileInput
            disabled={props.submitting}
            label="Background"
            value={get(props.values, 'androidIconBackgroundUrl', '')}
            onChange={(value) => props.onChange('androidIconBackgroundFile', value)}
            errorText={get(props.errors, 'androidIconBackgroundFile', null)}
            accept="image"
          />
          <small style={{ position: 'absolute', bottom: 6 }}>
            1024x1024 image that will be as background layer of Android adaptative icon
          </small>
        </Column>
        <Column size={4}>
          <LocalFileInput
            disabled={props.submitting}
            label="Logo"
            value={get(props.values, 'androidIconLogoUrl', '')}
            onChange={(value) => props.onChange('androidIconLogoFile', value)}
            errorText={get(props.errors, 'androidIconLogoFile', null)}
            accept="image"
          />
          <small style={{ position: 'absolute', bottom: 6 }}>
            1024x1024 image that will be as foreground layer of Android adaptative icon
          </small>
        </Column>
      </Row>
      <Row>
        <Column size={6}>
          <TextInput
            disabled={props.submitting}
            label="iOS Store URL"
            value={get(props.values, 'iosStoreUrl', '')}
            onChange={(value) => props.onChange('iosStoreUrl', value)}
            errorText={get(props.errors, 'iosStoreUrl', null)}
          />
        </Column>
        <Column size={6}>
          <TextInput
            disabled={props.submitting}
            label="Android Store URL"
            value={get(props.values, 'androidStoreUrl', '')}
            onChange={(value) => props.onChange('androidStoreUrl', value)}
            errorText={get(props.errors, 'androidStoreUrl', null)}
          />
        </Column>
      </Row>
      <Row>
        <Column size={6}>
          <TextInput
            disabled={props.submitting}
            label="EAS Project ID"
            value={get(props.values, 'easProjectId', '')}
            onChange={(value) => props.onChange('easProjectId', value)}
            errorText={get(props.errors, 'easProjectId', null)}
          />
        </Column>
        <Column size={6}>
          <TextInput
            disabled={props.submitting}
            label="Deep linking schema"
            value={get(props.values, 'deepLinkingSchema', '')}
            onChange={(value) => props.onChange('deepLinkingSchema', value)}
            errorText={get(props.errors, 'deepLinkingSchema', null)}
          />
        </Column>
      </Row>
      <Separator />
      <div
        style={{
          textAlign: 'right',
          marginBottom: 20,
        }}
      >
        <Button icon="close" onClick={props.onDiscard} label="Cancel" />
        &emsp;
        <Button
          icon="check"
          type="primary"
          disabled={props.submitting || !props.isDirty()}
          loading={props.submitting}
          buttonType="submit"
          label="Save"
        />
      </div>
    </form>
  </Dialog>
);

WhitelabelConfigMobileDistributionForm.propTypes = {
  onSubmit: PropTypes.func,
  onDiscard: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

WhitelabelConfigMobileDistributionForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onDiscard: () => false,
};

export default WhitelabelConfigMobileDistributionForm;
